import { render, staticRenderFns } from "./GroupDelete.vue?vue&type=template&id=4aca974d&scoped=true&"
import script from "./GroupDelete.vue?vue&type=script&lang=js&"
export * from "./GroupDelete.vue?vue&type=script&lang=js&"
import style0 from "./GroupDelete.vue?vue&type=style&index=0&id=4aca974d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aca974d",
  null
  
)

export default component.exports